export const allCategoriesSubCategories = [
    { value: "Seating", label: "Seating" },
    { value: "Tables", label: "Tables" },
    { value: "Storage", label: "Storage" },
    { value: "Bedroom", label: "Bedroom" },
    { value: "Outdoor Furniture", label: "Outdoor Furniture" },
    { value: "Wall Decor", label: "Wall Decor" },
    { value: "Art", label: "Art" },
    { value: "Accents", label: "Accents" },
    { value: "Botanicals", label: "Botanicals" },
    { value: "Re-chargeable/Plug-in", label: "Re-chargeable/Plug-in" },
    { value: "Hardwired", label: "Hardwired" },
    { value: "Outdoor Lighting", label: "Outdoor Lighting" },
    { value: "Fans", label: "Fans" },
    { value: "Kitchen Accessories", label: "Kitchen Accessories" },
    { value: "Appliances", label: "Appliances" },
    { value: "Bath", label: "Bath" },
    { value: "Bedroom", label: "Bedroom" },
    { value: "Mattresses", label: "Mattresses" },
    { value: "Area Rugs", label: "Area Rugs" },
    { value: "Runner Rugs", label: "Runner Rugs" },
    { value: "Outdoor Rugs", label: "Outdoor Rugs" }
  ]
  